// Mirrors /Users/eu/Documents/lk-0.5.6-admin/lk-0.5.6/resources/js/auth.js semantics.
// localStorage tokens with optional `miniapp_` prefix when running embedded.
export const PANEL_AUTH_CHANGED_EVENT = 'panel:auth-changed';
function emitPanelAuthChanged() {
    window.dispatchEvent(new CustomEvent(PANEL_AUTH_CHANGED_EVENT));
}
export function isMiniappContext() {
    if (window.name === 'opengater_miniapp')
        return true;
    if (localStorage.getItem('miniapp_access_token')) {
        window.name = 'opengater_miniapp';
        return true;
    }
    return false;
}
export function tokenPrefix() {
    return isMiniappContext() ? 'miniapp_' : '';
}
export function getAccessToken() {
    return localStorage.getItem(tokenPrefix() + 'access_token');
}
export function getRefreshToken() {
    return localStorage.getItem(tokenPrefix() + 'refresh_token');
}
export function saveTokens(accessToken, refreshToken) {
    localStorage.setItem(tokenPrefix() + 'access_token', accessToken);
    if (refreshToken)
        localStorage.setItem(tokenPrefix() + 'refresh_token', refreshToken);
    emitPanelAuthChanged();
}
export function clearTokens() {
    const p = tokenPrefix();
    localStorage.removeItem(p + 'access_token');
    localStorage.removeItem(p + 'refresh_token');
    emitPanelAuthChanged();
}
export function isAuthenticated() {
    return !!getAccessToken();
}
